import React from 'react';
import { ScreenRedirect } from '@jira/platform__routing-screen-redirect/src/ui/ScreenRedirect.tsx';

export const ProjectsDirectoryManageRedirect = (): React.JSX.Element => (
	<ScreenRedirect to="/jira/settings/projects/manage" />
);
